import { RootDispatch, RootState } from 'store/types';
import { SnackType, Snack } from './types';
import { snacksDataSelector } from './selectors';

export const CREATE_SNACK = 'SNACKS.CREATE_SNACK';
export const CLOSING_SNACK = 'SNACKS.CLOSING_SNACK';
export const REMOVE_SNACK = 'SNACKS.REMOVE_SNACK';

export const createSnack = (type: SnackType, snack?: Snack) => ({
  type: CREATE_SNACK,
  payload: { type, ...snack }
});

export const closeSnack = (opts: { reset?: boolean } = {}) => (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  const snacks = snacksDataSelector(getState());
  const payload = opts.reset ? [] : [...snacks.slice(1)];

  dispatch({ type: CLOSING_SNACK });

  setTimeout(() => {
    dispatch({ type: REMOVE_SNACK, payload });
  }, 500);
};
